module.exports = __webpack_public_path__ + "static/media/trash-restore.f8a15ce3.svg";